<template>
  <div class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>分隊管理</h3>
          <hr />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="col-md-6">
          <h4 class="col-md-3 fontSize20">搜尋關鍵字:</h4>
          <input
            type="text"
            v-model="kw"
            required="required"
            class="inputstyle col-md-4 fontSize14 selectstyle"
            placeholder="分隊名"
          />
          <button
            type="button"
            @click="onSearchBtnClick"
            class="mybtnstyle btn-success selectstyle"
          >
            搜尋
          </button>
        </div>
        <div class="col-md-6">
          <div class="col-md-9 selectstyle">
            <router-link
              class="mybtnstyle btn-dark white_textcolor"
              :to="{ path: '/main/addGroup' }"
            >
              新增分隊
            </router-link>
            <h4 class="col-md-5">
              <i class="fa fa-user"></i>
              分隊總數:
            </h4>
            <h4 class="col-md-2 red_textcolor">{{ group_num }}</h4>
          </div>
        </div>
      </div>
    </div>
    <div class="x_content move_down">
      <div class="table-responsive">
        <table class="table table-striped jambo_table bulk_action word_center">
          <thead>
            <tr class="headings">
              <th class="column-title word_center">序號</th>
              <th class="column-title word_center">分隊名</th>
              <th class="column-title word_center">聯絡人(或隊長)</th>
              <th class="column-title no-link last word_center">
                <span class="nobr">查詢/修改</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(group, index) in filter_list">
              <tr
                v-if="group_num > 0"
                v-bind:class="{ even: index % 2 == 0, odd: index % 2 != 0 }"
                class="pointer"
              >
                <td class=" ">{{ index + 1 }}</td>
                <td class=" ">{{ group.name }}</td>
                <td class=" ">{{ group.driver.name }}</td>
                <td class="last">
                  <!-- <a class="red_textcolor" @click='onDetailBtnClick(driver.id)'>檢視</a> -->
                  <router-link
                    class="red_textcolor"
                    :to="{ name: 'GroupDetail', params: { id: group.id } }"
                  >
                    查詢/修改
                  </router-link>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import API from '../../assets/js/libs/API'
import Cookies from 'js-cookie'
import Group from '../../assets/js/libs/Group'
var group = new Group()

export default {
  name: 'GroupList',
  data() {
    return {
      list: [],
      filter_list: [],
      kw: '',
    }
  },
  methods: {
    onSearchBtnClick() {
      this.filter_list = this.list.filter((driver) => {
        let haskey = false
        for (var key in driver) {
          if (key == 'id') continue
          driver[key].toString()
          if (driver[key].toString().includes(this.kw)) {
            haskey = true
          }
        }
        return haskey
      })
    },
  },
  computed: {
    group_num() {
      return this.list.length
    },
  },
  mounted() {
    group
      .getList()
      .then((res) => {
        this.list = res.list
        this.filter_list = res.list
      })
      .catch((e) => {
        console.log(e)
      })
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/pages/group/GroupList.vue